<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col md="6" sm="6" lg="4" v-for="card in cards" :key="card.id">
        <v-card
          class="elevation-0 rounded-0 withdraw-card"
          :class="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-1'"
        >
          <v-card-actions class="paymentImage">
            <v-img height="155" contain :src="card.image" :alt="card.alter">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card-actions>
          <v-card-actions>
            <div class="value">
              <span>{{ card.paymentTitle }}</span>
              <span>{{ card.bankName }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value">
              <span>{{ card.currencyTitle }}</span>
              <span>{{ card.currencyName }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="value">
              <span>{{ card.timeTitle }}</span>
              <span>{{ card.timeFixed }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value mr-6">
              <span>{{ card.feeTitle }}</span>
              <span>{{ card.totalFee }}</span>
            </div>
          </v-card-actions>

          <v-card-actions class="pb-0 pt-3">
            <v-btn
              to="/withdraw-details"
              tile
              elevation="0"
              class="text-capitalize btn-account"
              color="teal-lighten-1"
              >Select this method</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    cards: [
      {
        id: 1,
        paymentTitle: "Method",
        bankName: "Bank Transfer",
        currencyTitle: "currency",
        currencyName: "USD",
        timeTitle: "Processing Time",
        timeFixed: "1-2 hours",
        feeTitle: "Fees",
        totalFee: "$12",
        image: require("../../assets/payments/bank.png"),
        alter: "Bank Transfer",
      },
      {
        id: 2,
        paymentTitle: "Method",
        bankName: "Cash Transfer",
        currencyTitle: "currency",
        currencyName: "USD",
        timeTitle: "Processing Time",
        timeFixed: "1-2 hours",
        feeTitle: "Fees",
        totalFee: "$12",
        image: require("../../assets/payments/cash.png"),
        alter: "Cash Transfer",
      },
      {
        id: 3,
        paymentTitle: "Method",
        bankName: "Crypto Transfer",
        currencyTitle: "currency",
        currencyName: "USDT",
        timeTitle: "Processing Time",
        timeFixed: "1-2 hours",
        feeTitle: "Fees",
        totalFee: "$12",
        image: require("../../assets/payments/crypto.png"),
        alter: "Crypto",
      },
      {
        id: 4,
        paymentTitle: "Method",
        bankName: "Mastercard Transfer",
        currencyTitle: "currency",
        currencyName: "USD",
        timeTitle: "Processing Time",
        timeFixed: "1-2 hours",
        feeTitle: "Fees",
        totalFee: "$12",
        image: require("../../assets/payments/mastercard.png"),
        alter: "Mastercard",
      },
      {
        id: 5,
        paymentTitle: "Method",
        bankName: "Skrill Transfer",
        currencyTitle: "currency",
        currencyName: "USD",
        timeTitle: "Processing Time",
        timeFixed: "1-2 hours",
        feeTitle: "Fees",
        totalFee: "$12",
        image: require("../../assets/payments/skrill.png"),
        alter: "Skrill",
      },
      {
        id: 6,
        paymentTitle: "Method",
        bankName: "Neteller Transfer",
        currencyTitle: "currency",
        currencyName: "USDT",
        timeTitle: "Processing Time",
        timeFixed: "1-2 hours",
        feeTitle: "Fees",
        totalFee: "$12",
        image: require("../../assets/payments/neteller.png"),
        alter: "Neteller",
      },
    ],
  }),
};
</script>
